module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("CHAPTER I")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(" was, I shall have to admit, a dark and stormy night. I have always thought it odd that so many crimes have taken place to the accompaniment of howling winds and nightmare tempests. It is odd, but not altogether unaccountable, for they are the supremely right accompaniment. And when I look back on the affair which reached its climax that evening, I realize that the weather could not well have been otherwise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I was staying at Braxham, a country town in one of the home counties. Actually, I like country towns. Most people say dogmatically that they must either have “the real country” or London itself. They affect to find places like Braxham—or Horsham, or Ashford, or Chelmsford or East Grinstead—provincial and dull. But I disagree. There is just enough population to form a self-contained world, and in that world surprising things take place which never reach the London Press, and types and characters develop freely, and situations become tense, and life has a dramatic way of twisting itself about. And it is all visible, audible, notable—the ideal theatre for any one like me, who wants to see things happen.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("But I had another reason for staying at Braxham. My old friend Sergeant Beef, after ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("his unexpected solution of the Thurston murder,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn_1",
      "id": "fn-1"
    }
  }, [_vm._v("1")]), _vm._v(" had been promoted to this larger area. And on the evening in question, Wednesday, February 22nd, I was actually in his excellent company in the public bar of the Mitre.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Now Sergeant Beef was essentially a country policeman. His red-veined face and straggling ginger moustache, his slow movements and deliberate and plodding manner of thought, stamped him as one of those irritating rustic individuals on bicycles who stop your car without apparent provocation, to see whether you have got a mirror. His dialect, too, the mixed and curious Cockney of the districts outside London, was not calculated to assist his promotion in a Force over-run by zestful public school boys, and gentlemen trained at the police college. But there was his record. From the time he had joined the Force, a gaping, ginger-haired youth, until now that he was in his late forties, he had never, it was said, “missed his man.” Whether it had been a stolen bicycle in the Sussex village he had ruled, or the murder of a doctor’s wife, as in his most recent case, Sergeant Beef had stolidly but relentlessly applied the simple principles of detection he had learnt, and eventually made his arrest. With everything else against him, he had been too successful to pass over, so that here he was, in charge, at the quite important little town of Braxham.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I, personally, was delighted. The Sergeant, for me, represented most that was worth while in the English character. He appeared almost "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("a fool, he was slow and independent, he was quite fearless, and his imagination was of the kind which did not appear till he took an important step. He loved a game and a glass, and he had the awed interest that Englishmen often have in the slick and sinister cleverness of the outwardly brilliant. And he always got there in the end.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("That evening he was in mufti, playing darts. Already, I gathered, there had been murmurs in the town that the new Sergeant—he had been at Braxham for a year or more, but he was still “new” there—spent too much of his time in local pubs. The Vicar was quite concerned about it, and talked of “a bad example.” There had even been a complaint to the Chief Constable. But Beef went his way. He never, he maintained, neglected his duty, and how he spent his free evenings was his own affair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He was a passionate dart-player. I use the adjective deliberately. To watch that solid and solemn man standing before the little round board with the three darts in his hand, preparing to score his final double, was a revelation. His glazed eyes were awakened, his impassive face was lit. He was immensely happy. And yet he was no champion. He “played a decent game,” people said. He “could hold his own.” But his style wasn’t spectacular. It was his fervour that was remarkable, not his skill.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("That evening he and I had been partners against Fawcett, the postman, and Harold, the ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("publican’s son. They had come in early, for the wind and rain which lashed the street had to be faced, and they had wanted to get the walk done with, so that they could settle down by the inn fire. The little public bar was inviting, clean and warm and the dripping overcoats and umbrellas hanging near the door were visibly steaming.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sergeant Beef and I had lost the first game, and my partner was not pleased. There was a lull in the play while we paid for the customary drinks, and as if to smooth over the slightly irritated atmosphere, Fawcett began to talk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I see young Rogers is home again,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sergeant Beef grunted. It was evident that he did not like “young Rogers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Shouldn’t mind having "), _c('em', [_vm._v("his")]), _vm._v(" job,” Fawcett continued.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What is it?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“He’s a steward on one of the liners that go to South America. He gets very good money.” Then, turning to Sergeant Beef, he said grinning—“Going to run him in this time, Sergeant?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Beef, appealed to in his professional capacity, answered in the pompous voice he kept for such moments. “If’e does anything wot calls for it,” he said, “’e will be arrested.” And he swallowed the rest of his beer.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Fawcett winked to me. “Regular young rascal, this Rogers,” he explained. “Always up to something. Last time he was home the Sergeant had him up for being drunk and disorderly. ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("And it’s not the first time he’s been in trouble.”")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Local boy?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“He’s not so much of a boy. Thirty-five or six, I should say. He’s a nephew of Mr. Rogers, the bootmaker, in the High Street. They’ve only lived here about five years.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“And he’s the black sheep of the town?” I suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“He’s a real bad hat,” said Fawcett. “Not just one of your happy-go-luckies. Why, I could tell you things about him, if we wasn’t in the hearing of the Law!” He nodded with a grin at the back of Sergeant Beef. “But his old aunt and uncle’s crazy about ’im. They won’t hear nothing against him. And he plays them up, of course. Decent old people, they are. It’s a shame. But he’ll come a cropper one of these days.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The publican, a Mr. Simmons, leaned over the bar. “He was in here to-day,” he said, “not long before we closed at half-past two. He came in with that Fairfax, who stays at the Riverside Hotel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That chap who comes down for the fishing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That’s him. They came in together, him and young Rogers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Go on!” said Fawcett, not very interested but feigning surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yes. I couldn’t help noticing because while they were in here a foreigner came in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“A foreigner?” said Beef. All foreigners to him were obviously suspect. “What sort of a foreigner?”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("“I didn’t like the look of him,” said Mr. Simmons. “Dark, he was. Might have been half Indian. He couldn’t speak a lot of English.”")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“There you are!” said Fawcett.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Well, as soon as young Rogers and Fairfax saw this fellow, they drank up and went out. I shouldn’t have noticed it, only when they’d gone the foreigner turned round to me and asks Fairfax’s name.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That’s funny,” admitted Beef. “Did ’e say any more?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No. He was gone in a minute. Almost as though he had gone after them, it was.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I never much cared for foreigners myself,” said Beef. And a moment later we were listening to war-time stories, calculated to rouse our distaste for foreigners of all sorts. However, this topic was exhausted in time, and was followed by a lull, in which the noise of the storm outside was unpleasantly noticeable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Soon we started to play the return match on the dart-board. Our backs were to the door, and though there were several entrances behind us while we played, we scarcely turned to see who had come in. The game was too exciting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It must have been about twenty past eight when, in the final “leg,” Sergeant Beef required only the double eighteen to win the match. Harold had left his partner the double top, on which Fawcett was almost a certainty, so that if the Sergeant missed this time the game was lost.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("“Well, I’m going to try for it,” he announced as he took the darts out of Harold’s hand.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There was a breathless silence. Sergeant Beef stood firmly on his heels, and prepared to throw. Every one in the bar had turned to see him. I was as tense as if my whole future hung on this, and I could see the Sergeant’s eyes alight with excitement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It was at this point that the street door opened, and someone entered and said, “Sergeant!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Beef did not turn round, but growled, “’Arf a minute, can’t you? I’m ’aving my turn.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He threw the first of his darts. It was outside the line—a quarter of an inch away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Sergeant!” This time the voice was loud and insistent. “I’ve come to give myself up. I’ve committed a murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Quicker than any of us, Sergeant Beef spun round. “That’s different,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We found ourselves staring towards the door, just inside which stood the man who, as I afterwards learnt, was called “young Rogers.” He was hatless, and the rain streamed down his face from his dark hair, while the shoulders of his suit were soaked. He was rather white as he looked across at us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Then, before any of us could move, he pulled out a small bottle, and, throwing his head back, swallowed the contents. There was a brief pause, then his body seemed to give one agonised spasm and he dropped with a double thud to the floor.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("We rushed forward, but Sergeant Beef was the first to examine him. He tugged at his ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("collar and opened it. The publican came hurrying round with a glass of water. But Beef, who had thrust his hand in to the fellow’s heart, looked up.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Dead as mutton,” he said, and rose to his feet.")])]), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn-1",
      "id": "fn_1"
    }
  }, [_vm._v("1")]), _vm._v(" See "), _c('em', [_vm._v("The case for Three Detectives")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2c77504","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Chapter01.vue
// module id = 72
// module chunks = 0